export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/9efedd6f8d84b8cf11b1862201b47d04.svg";